import { ButtonEl, ButtonFieldWrapper, ButtonGroup, Title } from "../DetailGraphSelector.styled";

export default function ButtonFieldView({ onActionRouteToPage }) {
    return (
        <ButtonFieldWrapper>
            <div>
                <Title>단일 상품 성과 확인</Title>
                <ButtonGroup>
                    <ButtonEl onClick={() => onActionRouteToPage('/sales-analysis/product/single-product')}>상품 별</ButtonEl>
                </ButtonGroup>
            </div>
        </ButtonFieldWrapper>
    )
}